import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import classNames from 'classnames';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Alert from '/@/components/bayer/alert';
import Card from '/@/components/card';
import Link from '/@/components/link';
import Message from '/@/components/message';
import settings from '/@/core/settings';
import { _ } from '/@/locale';
import { editProfile, logout } from '/@/store/session/actions';
import { getUser } from '/@/store/session/selectors';
import { mpTrackEvent } from '/@/store/tracking/mixpanel-events';
import { findLabel } from '/@/utils';
import { reverse } from '/@/utils/router';
import Title from '/@/v3/components/title';
import UserForm from '/@/views/users/user-form';
import styles from './styles.module.css';

@connect(
    (state) => ({
        user: getUser(state),
        offline: state.network.offline,
        cacheStatus: state.network.cacheStatus,
    }),
    (dispatch) => bindActionCreators({ logout, editProfile }, dispatch)
)
@autobind
export default class Profile extends Component {
    static contextTypes = {
        history: PropTypes.object,
    };

    getInitials() {
        return (this.props.user.first_name[0] + this.props.user.last_name[0]).toUpperCase();
    }

    getUserType() {
        return [
            findLabel(settings.choices.userTypes, this.props.user.type),
            findLabel(settings.choices.userSubtypes, this.props.user.subtype),
        ]
            .filter(Boolean)
            .join(' / ');
    }

    async handleLogout() {
        let logout = true;
        const confirmMessage = _(
            '¿Estás seguro de que querés cerrar sesión? Recién vas a poder entrar con tu usuario cuando vuelvas a estar online.'
        ); // eslint-disable-line
        if (this.props.offline && !window.confirm(confirmMessage)) {
            logout = false;
        }
        if (logout) {
            this.props.logout(logout);
            this.context.history(reverse('Landing'));
        }
    }

    renderUser() {
        if (this.props.user) {
            return (
                <div className={styles.information}>
                    <div className={classNames(styles.initials, styles.outline, styles[`theme-${settings.app.theme}`])}>
                        {this.getInitials()}
                    </div>
                    <div className={styles.name}>
                        {this.props.user.first_name} {this.props.user.last_name}
                    </div>
                    {this.props.user.internalProfileEnabled && (
                        <div className={styles.userInternalProfile}>
                            <CheckCircleIcon
                                sx={{ fontSize: 20, color: (t) => `${t.palette.success.main} !important` }}
                            />
                            {_('Perfil interno activado')}
                        </div>
                    )}
                    <div className={styles.extra}>{this.getUserType()}</div>
                </div>
            );
        }

        return (
            <div className={styles.information}>
                <div className={styles.initials}>?</div>
                <div className={styles.name}>{_('Invitado/a')}</div>
            </div>
        );
    }

    renderButtons() {
        return (
            <Fragment>
                {this.props.user && this.props.offline && (
                    <Message>{_('Para modificar tu perfil necesitás estar online.')}</Message>
                )}
                <Stack direction='column' spacing={1}>
                    {this.props.user && this.props.user.has_usable_password && (
                        <div className={styles.marginBtnChangePass}>
                            <Link to='PasswordChange'>
                                <Button
                                    variant='contained'
                                    onClick={() => mpTrackEvent('Password change began', undefined)}
                                >
                                    {_('Modificar contraseña')}
                                </Button>
                            </Link>
                        </div>
                    )}
                    <Link to='Landing'>
                        <Button variant='outlined' onClick={this.handleLogout}>
                            {_('Cerrar sesión')}
                        </Button>
                    </Link>
                </Stack>
            </Fragment>
        );
    }

    renderEditProfile() {
        return (
            <Fragment>
                {!this.props.user.type && (
                    <Alert severity='blue'>
                        {_('Necesitamos comprobar tus datos, por favor valida el formulario.')}
                    </Alert>
                )}
                <Title bolder size='md' align='left'>
                    {_('Editar Perfil')}
                </Title>
                <Card>
                    <UserForm
                        user={this.props.user}
                        onSubmit={this.props.editProfile}
                        showButtonDeleteAccount
                        disabledFields={['email']}
                        returnUrl={
                            this.props.location &&
                            this.props.location.state &&
                            this.props.location.state.params &&
                            this.props.location.state.params.returnUrl
                        }
                    />
                    <div className={styles.version}>
                        {_('Versión')}: {CONFIG.version}
                    </div>
                </Card>
            </Fragment>
        );
    }

    render() {
        if (!this.props.user) this.context.history('/');
        return (
            <div className={styles.root}>
                {this.renderUser()}
                {this.renderButtons()}
                {this.renderEditProfile()}
            </div>
        );
    }
}
